export default __webpack_public_path__ + "static/media/a1.664c6436.jpg";